import { createContext, useContext, useEffect, useState } from "react";

const CartContext = createContext();
const KEY = "sawd-cart";

export const CartProvider = ({ children }) => {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch { return []; }
  });
  useEffect(() => { localStorage.setItem(KEY, JSON.stringify(items)); }, [items]);

  const add = (item) => {
    setItems((prev) => {
      const key = `${item.kind}:${item.id}`;
      if (prev.some((p) => `${p.kind}:${p.id}` === key)) return prev;
      return [...prev, item];
    });
  };
  const remove = (kind, id) => setItems((prev) => prev.filter((p) => !(p.kind === kind && p.id === id)));
  const has = (kind, id) => items.some((p) => p.kind === kind && p.id === id);
  const clear = () => setItems([]);
  const total = items.reduce((s, i) => s + (i.price || 0), 0);

  return (
    <CartContext.Provider value={{ items, add, remove, has, clear, total, count: items.length }}>
      {children}
    </CartContext.Provider>
  );
};

export const useCart = () => useContext(CartContext);
